var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('store-recherche-provider',{attrs:{"name":"bonStockSortie","copy":_vm.bonStore}},[_c('listeBonStock',{attrs:{"isEntree":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }